var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.popupsAreBlocked && !_vm.popupWarningDismissed)?_c('banner-notice',{staticClass:"shadow",attrs:{"type":"warning"},on:{"click":() => { _vm.popupWarningDismissed = true }}},[_vm._v("Please enable pop-ups for this site")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }